var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarwinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Darwin Browser",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#0b3d66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 28,
    height: 30,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    width: 9,
    height: 10,
    rx: 2,
    fill: "#0b3d66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 17,
    width: 9,
    height: 10,
    rx: 2,
    fill: "#0b3d66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 35,
    r: 3,
    fill: "#0b3d66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 3,
    fill: "#0b3d66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 44,
    width: 6,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 44,
    width: 6,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 50,
    width: 14,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 50,
    width: 14,
    height: 3,
    rx: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarwinLogo);
export default __webpack_public_path__ + "static/media/darwin_logo.3568d76d9ac81516490a8ff28c2210ee.svg";
export { ForwardRef as ReactComponent };